import { useEffect, useMemo, useState } from 'react'

import { useRouter } from 'next/router'

import { Locale, PartnershipSection } from '@/service/api/landingPage'
import { useScreen } from '@/store/screen'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const usePartnership = () => {
  const { windowSize } = useScreen()

  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale
  const { asPath } = router

  const [partnershipData, setPartnershipData] = useState<PartnershipSection>(
    () =>
      getLPTranslationData({
        landingPage: asPath === '/software' ? 'software' : 'entre-em-contato',
        container: 'partnershipContainer',
        locale,
      }) as PartnershipSection,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: asPath === '/software' ? 'software' : 'entre-em-contato',
      container: 'partnershipContainer',
      locale,
    }) as PartnershipSection

    setPartnershipData(translationsObject)
  }, [locale, asPath])

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h4' as const,
        subtitle: 'b1' as const,
      },
      791: {
        title: 'h5' as const,
        subtitle: 'b4' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 791) return fontSizesByScreenSize[791]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
    partnershipData,
  }
}
